class AddOnDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = this.querySelector('[data-add-on-header]');
    this.drawer = this.querySelector('[data-add-on-drawer]');
    this.init();
  }

  init() {
    this.header.addEventListener('click', () => {
      if (this.classList.contains('open')) {
        this.closeDrawer();
        this.drawer.classList.remove('open');
      } else {
        this.openDrawer();
        this.drawer.classList.add('open');
      }
    });
    this.header.addEventListener('keyup', (event) => this.handleMenuButtonADA(event));
  }

  handleMenuButtonADA(event) {
    const { key } = event;
    if (key === 'Escape' && this.classList.contains('open')) {
      this.header.closeDrawer();
    } else if (key === 'Enter' && this.classList.contains('open') == true) {
      this.closeDrawer();
    }
  }

  openDrawer() {
    this.classList.add('open');
  }

  closeDrawer() {
    this.classList.remove('open');
  }
}
if (!customElements.get('add-on-drawer')) customElements.define('add-on-drawer', AddOnDrawer);
